// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { setWaitState } from 'store/reducers/selfCheckIn/actions';
import { gtmContactPreferenceMethod } from 'store/reducers/gtm/actions';

// Component
import AdvisorAssistance from './AdvisorAssistance';

// Selectors
import {
  getTransportationLabel,
  getContactInfo
} from 'store/reducers/appointment/selectors';
import {
  getSelfCheckinWaitState,
  getSelfCheckInFlow
} from 'store/reducers/selfCheckIn/selectors';
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';
import { showSCIProgressBar } from 'store/reducers/optimizelyABTest/selectors';

const mapStateToProps = state => ({
  transportationLabel: getTransportationLabel(state),
  waitState: getSelfCheckinWaitState(state),
  dealerCountryCode: getDealerCountryCode(state),
  contactInfo: getContactInfo(state),
  selfCheckInFlow: getSelfCheckInFlow(state),
  showSCIProgressBar: showSCIProgressBar(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      setWaitState,
      gtmContactPreferenceMethod
    }
  )
)(AdvisorAssistance);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/SpeakToAdvisorPage/AdvisorAssistance/AdvisorAssistanceContainer.js